export const fontFamily = {
  sans: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
} as const;

export const fontSize = {
  xs: ['0.75rem', { lineHeight: '1rem' }],
  sm: ['0.875rem', { lineHeight: '1.25rem' }],
  base: ['1rem', { lineHeight: '1.5rem' }],
  lg: ['1.125rem', { lineHeight: '1.75rem' }],
  xl: ['1.25rem', { lineHeight: '1.75rem' }],
  '2xl': ['1.5rem', { lineHeight: '2rem' }],
  '3xl': ['1.875rem', { lineHeight: '2.25rem' }],
} as const;

export const fontWeight = {
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
} as const;

/** Semantic text styles — map to Tailwind utilities in components */
export const textStyles = {
  pageTitle: 'text-2xl font-bold text-gray-900',
  sectionTitle: 'text-lg font-semibold text-gray-900',
  cardTitle: 'text-base font-semibold text-gray-900 lg:text-lg',
  body: 'text-sm text-gray-700',
  bodyMuted: 'text-sm text-gray-600',
  label: 'text-sm font-medium text-gray-700',
  caption: 'text-xs text-gray-500',
  link: 'text-sm font-medium text-brand-emphasis transition-colors hover:text-brand-muted',
} as const;
